import {
  CardModule,
  CheckboxModule,
  DropdownModule,
  RadioButtonModule,
  AlertModule,
  TooltipModule,
} from 'axis-components';
import { CommonModule, JsonPipe, SlicePipe } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ReactiveFormsModule, FormGroup } from '@angular/forms';
import { BaseRules, TextValues } from './kansas.model';
import { PipBaseStateComponent } from '../pip-base-state.component';
import { TruncateModule } from 'axis-components/truncate';

@Component({
  selector: 'app-kansas',
  templateUrl: './kansas.component.html',
  styleUrls: ['./kansas.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    CardModule,
    CheckboxModule,
    DropdownModule,
    ReactiveFormsModule,
    RadioButtonModule,
    AlertModule,
    SlicePipe,
    JsonPipe,
    TruncateModule,
    TooltipModule,
  ],
})
export class KansasComponent extends PipBaseStateComponent<
  BaseRules,
  TextValues
> {
  @Input() set formGroup(form: FormGroup | null) {
    if (form) {
      super.getJsonRuleFiles('kansas', form);
    }
  }
  @Input() set isReview(review: boolean) {
    if (review) {
      super.getJsonRuleFiles('kansas', null);
    }
  }

  override dynamicRuleQueryBuilder(): string {
    return '';
  }
}
